import { Column } from '@tanstack/react-table';
import { utilityColumnsIds } from '../hooks/columnHooks';

export const getFirstVisibleColumn = (
  columnOrder: string[] | undefined,
  hiddenColumns: string[] | undefined,
  columns: Column<object, unknown>[] | undefined
): string | undefined => {
  const ignoredColumns = utilityColumnsIds as string[];

  if (!columnOrder || !hiddenColumns || (!columnOrder.length && !hiddenColumns.length)) {
    return columns?.find((column) => !ignoredColumns.includes(column.id))?.id;
  }
  const visibleColumns = columnOrder.filter((column) => !hiddenColumns.includes(column));

  return visibleColumns[0];
};
